<template>
  <div>
    <top-bar></top-bar>
    <div class="nav-bar-box">
      <div style="display: flex;width: 17rem;flex-direction: row-reverse;">
        <el-popover trigger="hover" style="float: right">
          <div class="userInfo-box" align="center">
            <table>
              <tr>
                <td>用户账号：</td>
                <td>{{name}}</td>
              </tr>
              <tr>
                <td colspan="2" align="center">
                  <el-button size="small" @click="logout" style="width: 70%;color: red;border-color:red;">退出登录</el-button>
                </td>
              </tr>
            </table>
          </div>
          <el-button class="but" slot="reference">
            <div style="width: 33%;padding-right: 1.5rem">
              <svg-icon icon-class="user" class="icon"></svg-icon>
              {{ name }}
            </div>
          </el-button>
        </el-popover>
      </div>
    </div>
    <div class="main-div">
      <div class="auth-title">请进行短信认证</div>
      <div class="flex-div">
        <el-input class="send-input" v-model="vcode" placeholder="请输入短信验证码" :maxlength="6"  @keyup.enter.native="check"></el-input>
        <el-button class="send-button" @click="send" :disabled="sendStatus">{{sendContent}}</el-button>
      </div>
      <el-button type="primary" class="auth-button" @click="check">认证</el-button>
    </div>
  </div>
</template>

<script>
  import TopBar from '@/views/layout/components/TopBar'
  import {mapGetters} from 'vuex'
  import {sendVcode, smsAuth} from  '@/api/smsAuth'
  export default {
    name: 'SmsAuth',
    components: {
      TopBar
    },
    data() {
      return {
        vcode: '',
        sendContent: '发送验证码',
        sendStatus: false,
        sendTimer: null
      }
    },
    computed: {
      ...mapGetters([
        'userId',
        'name'
      ]),
    },
    destroyed() {
      this.clearTimer()
    },
    methods: {
      /**
       * 退出登录
       */
      logout() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload()
        })
      },
      /**
       * 发送短信验证码
       */
      send() {
        // 判断是否可发送验证码
        if (!this.sendStatus) {
          this.sendStatus = true
          let sec = 60
          this.sendContent = sec + 's'
          this.sendTimer = setInterval(() => {
            sec--
            if (sec === 0) {
              this.clearTimer()
            } else {
              this.sendContent = sec + 's'
            }
          },1000)
        }
        // 发送验证码
        sendVcode(this.userId).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: res.message
            })
          } else {
            this.clearTimer()
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        }).catch(() => {
          this.clearTimer()
        })
      },
      /**
       * 验证短信验证码
       */
      check() {
        if (!this.vcode || this.vcode.length !== 6) {
          this.$message({
            type: 'error',
            message: '请输入符合格式的验证码'
          })
          return
        }
        smsAuth(this.vcode).then(res => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: res.message
            })
            // 跳转首页
            this.$router.push({path: '/'})
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        }).catch(() => {})
      },
      /**
       * 删除定时器
       */
      clearTimer() {
        this.sendContent = '发送验证码'
        this.sendStatus = false
        if (this.sendTimer !== null) {
          clearInterval(this.sendTimer)
          this.sendTimer = null
        }
      }
    }
  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">
  .auth-title {
    margin-top: 20px;
    font-size: 30px;
    font-weight: bold;
  }
  .flex-div {
    display: flex;
    margin-top: 10vh;
    .send-button {
      width: 120px;
    }
    .send-input {
      width: 200px;
      margin-right: 10px;
    }
  }
  .auth-button {
    width: 330px;
    margin-top: 10px;
  }
  .main-div {
    padding-left: 8%;
    padding-right: 8%;
    background-color: #f4f8f9;
    min-height: calc(100vh - 100px);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .icon:hover {
    color: #00A5B2;;
  }
  .nav-bar-box {
    padding-left: 8%;
    padding-right: 8%;
    height: 40px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    .nav-bar-menu {
      display: flex;
      align-items: center;
    }
    .user-show-box {
      display: flex;
    }
    .but {
      //消除button的默认样式
      margin: 0;
      padding: 0;
      border: 1px solid transparent; //自定义边框
      outline: none; //消除默认点击蓝色边框效果
      background-color: transparent;
    }
  }
  td {
    padding: 5px;
  }
</style>
